module.exports = __webpack_public_path__ + "img/guide_bg.f1b4172e.png";